<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && resource">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<table
							class="table"
							*ngIf="resource">
							<tbody>
								<tr>
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ resource.id }}</td>
								</tr>
								<tr>
									<td>{{ 'labels.fname' | translate }}</td>
									<td>{{ resource.fname }}</td>
								</tr>
								<tr>
									<td>{{ 'labels.lname' | translate }}</td>
									<td>{{ resource.lname }}</td>
								</tr>
								<tr>
									<td>{{'labels.consultant' | translate }}</td>
									<td>{{ consultant.name }}</td>
								</tr>

								<tr *ngFor="let key of keys">
									<td>{{'labels.'+ key | translate }}</td>
									<td>{{ resource[key] }}</td>
								</tr>
								<tr>
									<td>{{'labels.insdate' | translate }}</td>
									<td>
										{{ resource.insdate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<tr>
									<td>{{'labels.moddate' | translate }}</td>
									<td>
										{{ resource.moddate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>

								<div class="row mt-1">
									<div class="col">
										<button
											(click)="edit()"
											class="btn btn-primary">
											{{'labels.edit' | translate}}
										</button>
									</div>
								</div>

							</tbody>
						</table>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="resource"
							[bootstrap]="true"
							(change)="attachmentsChanged()"
							[canvalidate]="canvalidate"
							[eid]="resource.id"></app-attachments>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="inserimentoore">
					<a
						routerLink="."
						fragment="inserimentoore"
						ngbNavLink>
						Inserimento Ore
					</a>
					<ng-template ngbNavContent>
						<app-consultantresource-presenceupdate [consultantresource]="resource"></app-consultantresource-presenceupdate>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">
			{{'errors.loading.resource' | translate}}
		</app-card>

	</div>
</div>
